import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './edit_postal_code.less'
import TextBox from 'components/common/text_box'
import EditForm from '../edit_form'
import { HeadingText } from '@paypalcorp/pp-react'
import { POOLS_CAMPAIGN_TYPES } from 'shared/shared_consts'

const { CROWD_FUNDING } = POOLS_CAMPAIGN_TYPES
const i18n = getI18n('components/edit_glimpse/edit_postal_code')

class EditPostalCode extends React.Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    campaignType: PropTypes.string,
  }

  render() {
    const {
      fields: { postalCode },
      campaignType,
    } = this.props

    return (
      <EditForm {...this.props}>
        {campaignType === CROWD_FUNDING ? (
          <HeadingText size="md" styleName="title_cf">
            {i18n('title_cf')}
          </HeadingText>
        ) : (
          <div styleName="title" role="heading" aria-level="1">
            {i18n('title')}
          </div>
        )}
        <TextBox
          title={i18n('postal_code')}
          dataNemo="postal-code"
          {...postalCode}
        />
        <button
          data-nemo="save"
          data-pa-click="save"
          className="vx_btn vx_btn-block"
          styleName="save-button"
        >
          {i18n('save')}
        </button>
      </EditForm>
    )
  }
}

export default cssModules(EditPostalCode, styles)
